import { createFileRoute } from '@tanstack/react-router';

import { ProductScreen } from '@/features/catalog/product/ProductScreen';

/** Новый товар (AUI-CAT-02) — подчинённая страница каталога. */
export const Route = createFileRoute('/_app/catalog_/products_/new')({
  component: NewProductRoute,
});

function NewProductRoute() {
  return <ProductScreen />;
}
